
import { AutoComplete, Select } from 'antd';
import { isEmpty } from 'lodash';
import React, { ReactElement, useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store';
import { convertToValidStr } from '../../../../utils/utility';
import { NON_NAME_REGEX, MAX_CHARACTERS_LIMIT } from '../../../constants/commonConstants';
import { useGetFormConfig } from '../../../hooks/useFormConfig';
import FormItem from '../FormItem/FormItem';

export const FormAutoCompleteWithPrefix = (props: any): (ReactElement | null) => {
  const [extraRules, setExtraRules] = useState<any[]>([]);
  const formConfig = useGetFormConfig(props);
  const selectRef = useRef<any>(null);
  const {
    disabled, options = [], placeholder, onChange: onChangeFromOrigin, onSelect, hidden, onFocus, onBlur,
    onSearch: onSearchOrigin, form, isName, key, allowClear, className, isPrefixRequired, isMultiPayer, isDetailPage, prefix,
    suggestedValue, isShowSuggestedValue, suggestedValuesMap, maxLengthValue, fieldLengthValue,
  } = formConfig;
  const { Option } = Select;
  const { claimDetails } = useSelector((state: RootState): any => state.admissionDetails);
  const isValidSuggestedValue = suggestedValuesMap?.[key] || suggestedValue;

  useEffect((): void => { // on load to set validation
    if (form.getFieldsValue([key])) {
      setExtraRules([{
      max: maxLengthValue ? fieldLengthValue?.[0] : (MAX_CHARACTERS_LIMIT),
      }]);
    }
  }, []);

  const onChange = (ele: any): void => {
    setExtraRules([]);
    onChangeFromOrigin(ele);
    if (form?.getFieldsValue(['doctorName'])) {
      setExtraRules([{
      max: maxLengthValue ? fieldLengthValue?.[0] : (MAX_CHARACTERS_LIMIT),
      }]);
    }
  };

  const onSelectOption = (option: any, value: any): any => {
    if (form?.getFieldsValue(['doctorName'])) {
      setExtraRules([{
      max: maxLengthValue ? fieldLengthValue?.[0] : (MAX_CHARACTERS_LIMIT),
      }]);
    }
    onSelect(value, option);
  };

  const onSearch = (value: string): void => {
    let validStr = convertToValidStr(value);
    if (isName) {
      validStr = validStr.replace(NON_NAME_REGEX, '');
    }
    if (form) {
      form.setFieldsValue({ [key]: validStr });
    }
    setExtraRules([{
      max: maxLengthValue || MAX_CHARACTERS_LIMIT,
    }]);
    onSearchOrigin(validStr);
  };

  const handleDropdownVisibleChange = (e: any): any => {
    e?.selectRef?.current?.scrollTo?.(0);
  };

  return (
    <div className={ isMultiPayer ? claimDetails?.doctorName ? 'doctor-multiClass' : 'no-doctor-name-multi' : claimDetails?.doctorName ? 'doctor' : 'no-doctor-name'}>
      <FormItem formConfig={formConfig} extraRules={extraRules}>
        <AutoComplete
          disabled={disabled}
          placeholder={placeholder}
          allowClear={allowClear}
          ref={selectRef}
          optionFilterProp="children"
          onSearch={onSearch}
          onChange={onChange}
          onSelect={(value: any, option: any): any => onSelectOption(option, value)}
          className={className}
          data-testid={key}
          onBlur={(): void => onBlur && onBlur()}
          onFocus={(): void => onFocus && onFocus()}
          onDropdownVisibleChange={(e: any): any => handleDropdownVisibleChange(selectRef?.current)}
          filterOption={(inputValue: string, option: any): boolean =>
            (option?.children || '').toUpperCase().indexOf(('' + inputValue).toUpperCase()) !== -1
          }
        >
          {
            options?.map((option: any): ReactElement => {
              let name = option;
              let value = option;
              if (option.value && option.name) {
                name = option.name;
                value = option.value || option.name;
              }
              if (typeof value !== 'string') {
                value = `${value}`;
              }
              return <Option key={value} value={name} data-testid={`${key}-${value}`}>{name}</Option>;
            })
          }
        </AutoComplete>
      </FormItem>
      {isDetailPage ? !isEmpty(claimDetails) &&
        isPrefixRequired && claimDetails?.doctorName &&  !hidden && <div className={'dr-overlay-detail'}>{prefix}</div> :
        (isPrefixRequired && !hidden) &&
          <div className={`dr-overlay ${isShowSuggestedValue && isValidSuggestedValue ? 'dr-t-43' : ''}`}>{prefix}</div>}
    </div>
  );
};

export default FormAutoCompleteWithPrefix;
